export default "__VITE_ASSET__DdVZdRJM__"